import Modal from 'components/common/Modal';
import Postcode from 'components/common/Postcode';
import { buttonStyle } from 'lib/styles/index';
import { changeRegisterForm } from 'modules/contractSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { validatePlaceInputs } from 'utils/validate';

const PlaceInsertModal = ({ closeModal, edit }) => {
  const dispatch = useDispatch();
  const { store, insertStore } = useSelector(
    ({ contract }) => contract.contractRegisterForm,
  );
  const [showPostcodeModal, setShowPostcodeModal] = useState(false);
  const [localStore, setLocalStore] = useState({
    name: '',
    address: '',
    detailAddress: '',
  });
  const { name, address, detailAddress } = localStore;
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (isSubmit && Object.keys(errors).length === 0) {
      setIsSubmit(false);
      dispatch(
        changeRegisterForm({ form: 'store', value: [...store, localStore] }),
      );
      closeModal();
    }
  }, [isSubmit, errors, dispatch, store, localStore, closeModal]);

  useEffect(() => {
    if (isEdit && Object.keys(errors).length === 0) {
      setIsEdit(false);
      dispatch(
        changeRegisterForm({
          form: 'insertStore',
          value: [...insertStore, localStore],
        }),
      );
      closeModal();
    }
  }, [isEdit, errors, dispatch, store, insertStore, localStore, closeModal]);

  const onSubmit = () => {
    setErrors(validatePlaceInputs(name, address, detailAddress));
    if (edit) {
      setIsEdit(true);
    } else {
      setIsSubmit(true);
    }
  };

  const onChange = e => {
    const { name, value } = e.target;
    setLocalStore({ ...localStore, [name]: value });
  };

  return (
    <Modal closeModal={closeModal}>
      {showPostcodeModal && (
        <Modal closeModal={() => setShowPostcodeModal(false)}>
          <Postcode
            setLocalStore={value =>
              setLocalStore({ ...localStore, address: value })
            }
            closeModal={() => setShowPostcodeModal(false)}
          />
        </Modal>
      )}
      <PlaceInsertModalBlock>
        <div className="place-insert-modal-title">장소 입력</div>
        <div className="place-insert-modal-row">
          <StyledInput
            type="text"
            placeholder="매장명"
            name="name"
            value={localStore.name}
            onChange={onChange}
          />
          {errors?.name && (
            <div className="place-insert-modal-error-msg">{errors.name}</div>
          )}
        </div>
        <div className="place-insert-modal-row">
          <div className="place-insert-modal-row-address">
            <StyledInput
              type="address"
              placeholder="주소"
              value={localStore.address}
              disabled
            />
            <button
              className="post-code-button"
              onClick={() => setShowPostcodeModal(true)}
            >
              주소
            </button>
          </div>
          {errors?.address && (
            <div className="place-insert-modal-error-msg">{errors.address}</div>
          )}
        </div>
        <div className="place-insert-modal-row">
          <StyledInput
            type="text"
            placeholder="상세주소"
            name="detailAddress"
            value={localStore.detailAddress}
            onChange={onChange}
          />
          {errors?.detailAddress && (
            <div className="place-insert-modal-error-msg">
              {errors.detailAddress}
            </div>
          )}
        </div>
        <StyledButton onClick={onSubmit}>입력</StyledButton>
      </PlaceInsertModalBlock>
    </Modal>
  );
};

export default PlaceInsertModal;

const PlaceInsertModalBlock = styled.div`
  width: 400px;
  padding: 2rem;
  display: flex;
  flex-direction: column;

  .place-insert-modal-title {
    margin-bottom: 1rem;
    font-weight: bold;
    text-align: center;
  }

  .place-insert-modal-row {
    margin-bottom: 0.8rem;
    display: flex;
    flex-direction: column;
  }

  .place-insert-modal-error-msg {
    margin-top: 0.2rem;
    margin-left: 0.5rem;
    display: flex;
    color: red;
    font-size: 11px;
  }

  .place-insert-modal-row-address {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .post-code-button {
    width: 50px;
    height: 30px;
    margin-left: 4px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 10px;
  border: solid 1px #dfdfdf;
  border-radius: 8px;
  font-size: 14px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const StyledButton = styled.button`
  ${buttonStyle}
`;
